import { Typography } from '@mui/material';
import styled from 'styled-components';

export const LongDescription = styled(Typography)`
  font-style: italic;
  font-size: 0.875rem;
  margin-top: 0.5rem;
`;
